import { render, staticRenderFns } from "./BadgeList.vue?vue&type=template&id=3eeb8b0c&"
import script from "./BadgeList.vue?vue&type=script&lang=js&"
export * from "./BadgeList.vue?vue&type=script&lang=js&"
import style0 from "./BadgeList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports